"use strict";
exports.__esModule = true;
var cookie_1 = require("@cian/utils/lib/shared/cookie");
var helpers_1 = require("./utils/helpers");
var promises_1 = require("./utils/promises");
var query_1 = require("./utils/query");
// adfox variant to get random string
var getRandomString = function () { return String(Math.floor(Math.random() * 4294967295) + 1); };
var addScript = function (_a) {
    var src = _a.src;
    var script = document.createElement('script');
    script.src = src;
    var scriptsContainer = document.getElementsByTagName('head')[0];
    scriptsContainer.appendChild(script);
    return script;
};
var getCustomParams = function () {
    var params = {};
    var cookie = cookie_1.parseCookies(document.cookie);
    if (cookie['QA-TestMode']) {
        params['puid32'] = 'test';
    }
    return params;
};
function getAdFoxBannerContext(params) {
    var pr = getRandomString();
    var pr1 = getRandomString();
    var customParams = getCustomParams();
    var paramsWithIds = Object.assign({ pr: pr, pr1: pr1 }, customParams, params);
    var fn = "_adFoxCallback" + paramsWithIds['pr1'];
    var script = addScript({
        src: "https://ads.adfox.ru/202100/prepareCode?" + query_1.serializeParams(paramsWithIds)
    });
    function destroy() {
        if (script.parentElement) {
            script.parentElement.removeChild(script);
        }
    }
    return promises_1.cancelAfter(
    // tslint:disable-next-line:no-any
    new Promise(function (resolve, reject) {
        script.addEventListener('error', function () {
            reject(new Error('Unpossible to load script'));
        });
        // tslint:disable-next-line:no-any
        window[fn] = function (context) {
            resolve(helpers_1.mapValues(helpers_1.decodeHtmlEntity, context));
        };
    }))
        .then(function (context) {
        destroy();
        return context;
    })["catch"](function (err) {
        destroy();
        throw err;
    });
}
exports.getAdFoxBannerContext = getAdFoxBannerContext;
//# sourceMappingURL=adfox_api.js.map